import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { RootLayout } from "@/components/layout/root-layout";
import { ErrorBoundary } from "@/components/shared/error-boundary";
import { DashboardPage } from "@/pages/dashboard";
import { InboxPage } from "@/pages/inbox";
import { ContactsPage } from "@/pages/contacts";
import { ChannelsPage } from "@/pages/channels";
import { NotFoundPage } from "@/pages/not-found";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route element={<RootLayout />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/inbox" element={<InboxPage />} />
            <Route path="/inbox/:inboxId" element={<InboxPage />} />
            <Route path="/contacts" element={<ContactsPage />} />
            <Route path="/channels" element={<ChannelsPage />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
